<template>
<!--Reusable compoenet-->
<div>
    <v-flex xs12 sm10 offset-sm1 md6 offset-md3 mt-3>
        <!--Radio buttons-->
        <v-container text-xs-center>
            <v-btn-toggle v-model="currentTab">
                <v-btn flat value="deposit" @click.prevent="$router.push({name: 'History / Deposit'})">
                    <v-icon xs class="transaction-icon">fas fa-wallet</v-icon>
                    Deposit
                </v-btn>
                <v-btn flat value="withdraw" @click.prevent="$router.push({name: 'History / Withdraw'})">
                    <v-icon xs class="transaction-icon">fas fa-money-bill-wave</v-icon>
                    Withdraw
                </v-btn>
                <v-btn flat value="transfer" @click.prevent="$router.push({name: 'History / Transfer'})">
                    <v-icon xs class="transaction-icon">fas fa-random</v-icon>
                    Transfer
                </v-btn>
            </v-btn-toggle>

            <!--Date pickers-->
            <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex xs6 sm6 md6>
                        <v-menu v-model="fromMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="fromDate" label="From" prepend-icon="event" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="fromDate" @input="fromMenu = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs6 lg6>
                        <v-menu v-model="toMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="toDate" label="To" prepend-icon="event" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="toDate" @input="toMenu = false"></v-date-picker>
                        </v-menu>

                    </v-flex>
                </v-layout>

                <v-flex xs12 lg>
                    <v-btn color="success" @click.prevent="desserts = null">
                        Search
                    </v-btn>

                    <v-btn color="error" @click.prevent="resetdate">
                        Reset
                    </v-btn>
                </v-flex>
            </v-container>

            <v-divider></v-divider>

            <!--Table-->
            <v-data-table v-if="desserts != null" :headers="headers" :items="desserts" class="elevation-1 mt-2">
                <template v-slot:items="props">
                    <td>{{ props.item.name }}</td>
                    <td class="text-xs-right">{{ props.item.calories }}</td>
                    <td class="text-xs-right">{{ props.item.fat }}</td>
                    <td class="text-xs-right">{{ props.item.carbs }}</td>
                    <td class="text-xs-right">{{ props.item.protein }}</td>
                    <td class="text-xs-right">{{ props.item.iron }}</td>
                </template>

            </v-data-table>
        </v-container>

    </v-flex>
</div>
</template>

<style scoped>
.transaction-icon {
    font-size: 14px;
    margin-right: 6px;
}
</style>

<script>
export default {
    name: "Affiliate",
    data() {
        return {
            selected: "",
            active: false,
            currentTab: this.tab,
            //date pickers
            // fromDate: new Date().toISOString().substr(0, 10),
            fromDate: '',
            // toDate: new Date().toISOString().substr(0, 10),
            toDate: '',
            fromMenu: false,
            toMenu: false,
            //sample table header and data
            headers: [{
                    text: 'Dessert (100g serving)',
                    align: 'left',
                    sortable: false,
                    value: 'name'
                },
                {
                    text: 'Calories',
                    value: 'calories'
                },
                {
                    text: 'Fat (g)',
                    value: 'fat'
                },
                {
                    text: 'Carbs (g)',
                    value: 'carbs'
                },
                {
                    text: 'Protein (g)',
                    value: 'protein'
                },
                {
                    text: 'Iron (%)',
                    value: 'iron'
                }
            ],
            desserts: [{
                    name: 'Frozen Yogurt',
                    calories: 159,
                    fat: 6.0,
                    carbs: 24,
                    protein: 4.0,
                    iron: '1%'
                },
                {
                    name: 'Ice cream sandwich',
                    calories: 237,
                    fat: 9.0,
                    carbs: 37,
                    protein: 4.3,
                    iron: '1%'
                },
                {
                    name: 'Eclair',
                    calories: 262,
                    fat: 16.0,
                    carbs: 23,
                    protein: 6.0,
                    iron: '7%'
                },
                {
                    name: 'Cupcake',
                    calories: 305,
                    fat: 3.7,
                    carbs: 67,
                    protein: 4.3,
                    iron: '8%'
                }
            ],
        }
    },
    props: ['tab', 'buttons'],
    methods: {
        resetdate: function () {
            this.toDate = "";
            this.fromDate = "";
            this.desserts = [{
                    name: 'Frozen Yogurt',
                    calories: 159,
                    fat: 6.0,
                    carbs: 24,
                    protein: 4.0,
                    iron: '1%'
                },
                {
                    name: 'Ice cream sandwich',
                    calories: 237,
                    fat: 9.0,
                    carbs: 37,
                    protein: 4.3,
                    iron: '1%'
                },
                {
                    name: 'Eclair',
                    calories: 262,
                    fat: 16.0,
                    carbs: 23,
                    protein: 6.0,
                    iron: '7%'
                },
                {
                    name: 'Cupcake',
                    calories: 305,
                    fat: 3.7,
                    carbs: 67,
                    protein: 4.3,
                    iron: '8%'
                }
            ];
        }
    }
}
</script>
